import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './work.styles'
import ContentHolder from '../../../content-holder/content-holder'
import Paper from 'pobble-components/dist/paper'
import WorksTable from './works-table/works-table.container'
import WorkSkeleton from './work-skeleton/work-skeleton'

class Work extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  render() {
    const { classes, pending } = this.props
    return (
      <ContentHolder>
        <Paper className={classes.paper}>
          {pending && <WorkSkeleton />}
          {!pending && <WorksTable />}
        </Paper>
      </ContentHolder>
    )
  }
}

export default injectSheet(styles)(Work)
